module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_008.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_008.png
// module id = 2324
// module chunks = 5